import i18n from '@/utils/i18n';
import Cookies from 'js-cookie'
import config from '@/config'
import { getHost } from '@/utils/index'
const hostPre = getHost(config.loginPath)
const TokenKey = `${hostPre}_auth_login_platform_token`
const isBYH = window.location.href.indexOf('from=byh') > -1
const isDevelopMent = process.env.NODE_ENV === 'development'
export const appIdKey = `${getHost(window.origin) || 'local_pms'}_appId`
export function getToken(key) {
  return Cookies.get(key || (isBYH ? 'byh_token' : TokenKey))
}

export function setToken(token, key) {
  if (!isDevelopMent && !key) {
    if (!isBYH) {
      return
    }
  }
  return Cookies.set(key || TokenKey, token, {
    expires: 30,         // 保存 30 天
    secure: true,        // ✅ 必须：否则 SameSite=None 会被忽略
    sameSite: 'None'     // ✅ 必须：否则 iframe 不会带 cookie
  });
}

export function removeToken(key) {
  if (key) {
    Cookies.remove(key)
  }
  return Cookies.remove(TokenKey)
}
